const translations = {
    en: {
      aboutUS: 'About US',
      blockedUsersMessage: '🚀 We are almost there! The official launch of Vision AI Stream is coming soon, and you will soon be able to explore all the amazing features we have prepared for you. Stay tuned, the countdown has begun! 🕒',
      usernameOrEmailPlaceholder: "Enter your email or username",
      passwordPlaceholder: "Enter your password",
      pageLanguageLabel: "Page Language",
      loginSuccess: "User logged in successfully!",
      loginError: "Incorrect username or password!",
      loginButton: 'Login/Register',
      loginButtonTooltip: 'This button allows you to log in or register. Use "email@example.com" for registration or just "username" (email without "@") for login.',
      invalidEmail: "Please enter a valid email address.",
      tokenResetError: "Failed to reset password. Please check if the token is valid or expired.",
      tokenResetSuccess: "Password successfully reset.",
      incorrectPasswordEmailLink: "Incorrect password. A link to reset your password has been sent to your email.",
      planStatusInvalid: "Invalid or missing plan status.",
      tokenPlaceholder: "Password reset token",
      newPasswordPlaceholder: "Enter your new password",
      resetPasswordButton: "Reset Password",
      passwordTooShort: "Password must be at least 6 characters long.",
      opportunityMessage: "Don't miss this opportunity! Edit videos with AI and try Vision AI Stream for free now. 🎬✨",
      enterEmailMessage: "🔥 Enter your email here right now to log in or create your account! 🚀",
      enterPasswordMessage: "🔥 Enter your password here right now to log in or create your account! 🚀"
    },
  
    pt: {
      aboutUS: 'Sobre Nós',
      blockedUsersMessage: '🚀 Estamos quase lá! O lançamento oficial do Vision AI Stream está chegando e, em breve, você poderá explorar todas as funcionalidades incríveis que preparamos para você. Fique de olho, a contagem regressiva já começou! 🕒',
      usernameOrEmailPlaceholder: "Digite seu email ou nome de usuário",
      passwordPlaceholder: "Digite a senha",
      pageLanguageLabel: "Idioma da Página",
      loginSuccess: "Usuário logado com sucesso!",
      loginError: "Usuário ou senha incorretos!",
      loginButton: 'Entrar/Registrar',
      loginButtonTooltip: 'Este botão permite que você entre ou registre-se. Use "email@exemplo.com" para registrar-se ou apenas "usuário" (email sem "@") para login.',
      invalidEmail: "Por favor, insira um e-mail válido.",
      tokenResetError: "Falha ao redefinir a senha. Verifique se o token é válido ou expirou.",
      tokenResetSuccess: "Senha redefinida com sucesso.",
      incorrectPasswordEmailLink: "Senha incorreta. Um link para redefinir sua senha foi enviado para o e-mail informado.",
      planStatusInvalid: "Status do plano inválido ou ausente.",
      tokenPlaceholder: "Token para redefinição de senha",
      newPasswordPlaceholder: "Digite sua nova senha",
      resetPasswordButton: "Redefinir Senha",
      passwordTooShort: "A senha deve ter pelo menos 6 caracteres.",
      opportunityMessage: "Não perca essa oportunidade! Edite vídeos com IA e teste o Vision AI Stream grátis agora. 🎬✨",
      enterEmailMessage: "🔥 Digite seu e-mail aqui agora mesmo para entrar ou criar sua conta! 🚀",
      enterPasswordMessage: "🔥 Digite sua senha aqui agora mesmo para entrar ou criar sua conta! 🚀"
    },
  
    es: {
      aboutUS: 'Sobre Nosotros',
      blockedUsersMessage: '🚀 ¡Estamos casi allí! El lanzamiento oficial de Vision AI Stream está por llegar, y pronto podrás explorar todas las increíbles funciones que hemos preparado para ti. ¡Mantente atento, la cuenta regresiva ha comenzado! 🕒',
      usernameOrEmailPlaceholder: "Introduce tu correo electrónico o nombre de usuario",
      passwordPlaceholder: "Ingrese su contraseña",
      pageLanguageLabel: "Idioma de la Página",
      loginSuccess: "¡Usuario conectado con éxito!",
      loginError: "¡Nombre de usuario o contraseña incorrectos!",
      loginButton: 'Iniciar sesión/Registrar',
      loginButtonTooltip: 'Este botón le permite iniciar sesión o registrarse. Use "correo@ejemplo.com" para registrarse o solo "nombre de usuario" (correo sin "@") para iniciar sesión.',
      invalidEmail: "Por favor, ingrese un correo electrónico válido.",
      tokenResetError: "Error al restablecer la contraseña. Verifique si el token es válido o ha expirado.",
      tokenResetSuccess: "Contraseña restablecida con éxito.",
      incorrectPasswordEmailLink: "Contraseña incorrecta. Se envió un enlace para restablecer su contraseña a su correo electrónico.",
      planStatusInvalid: "Estado del plan inválido o faltante.",
      tokenPlaceholder: "Token para restablecer la contraseña",
      newPasswordPlaceholder: "Ingrese su nueva contraseña",
      resetPasswordButton: "Restablecer contraseña",
      passwordTooShort: "La contraseña debe tener al menos 6 caracteres.",
      opportunityMessage: "¡No pierdas esta oportunidad! Edita videos con IA y prueba Vision AI Stream gratis ahora. 🎬✨",
      enterEmailMessage: "🔥 Ingresa tu correo electrónico aquí ahora mismo para iniciar sesión o crear tu cuenta. 🚀",
      enterPasswordMessage: "🔥 Ingresa tu contraseña aquí ahora mismo para iniciar sesión o crear tu cuenta. 🚀"
    },
  
    fr: {
      aboutUS: 'À Propos de Nous',
      blockedUsersMessage: '🚀 Nous y sommes presque ! Le lancement officiel de Vision AI Stream arrive bientôt, et vous pourrez bientôt explorer toutes les fonctionnalités incroyables que nous avons préparées pour vous. Restez à l\'écoute, le compte à rebours a déjà commencé ! 🕒',
      usernameOrEmailPlaceholder: "Entrez votre email ou nom d’utilisateur",
      passwordPlaceholder: "Entrez votre mot de passe",
      pageLanguageLabel: "Langue de la Page",
      loginSuccess: "Utilisateur connecté avec succès!",
      loginError: "Nom d'utilisateur ou mot de passe incorrect!",
      loginButton: 'Connexion/Enregistrement',
      loginButtonTooltip: 'Ce bouton vous permet de vous connecter ou de vous enregistrer. Utilisez "email@exemple.com" pour l’enregistrement ou uniquement "nom d’utilisateur" (e-mail sans "@") pour vous connecter.',
      invalidEmail: "Veuillez saisir une adresse e-mail valide.",
      tokenResetError: "Échec de la réinitialisation du mot de passe. Vérifiez si le jeton est valide ou expiré.",
      tokenResetSuccess: "Mot de passe réinitialisé avec succès.",
      incorrectPasswordEmailLink: "Mot de passe incorrect. Un lien de réinitialisation a été envoyé à votre adresse e-mail.",
      planStatusInvalid: "Statut de plan invalide ou manquant.",
      tokenPlaceholder: "Jeton de réinitialisation du mot de passe",
      newPasswordPlaceholder: "Entrez votre nouveau mot de passe",
      resetPasswordButton: "Réinitialiser le mot de passe",
      passwordTooShort: "Le mot de passe doit comporter au moins 6 caractères.",
      opportunityMessage: "Ne manquez pas cette opportunité ! Montez des vidéos avec l'IA et testez Vision AI Stream gratuitement dès maintenant. 🎬✨",
      enterEmailMessage: "🔥 Saisissez votre e-mail ici maintenant pour vous connecter ou créer votre compte ! 🚀",
      enterPasswordMessage: "🔥 Saisissez votre mot de passe ici maintenant pour vous connecter ou créer votre compte ! 🚀"
    },
  
    de: {
      aboutUS: 'Über Uns',
      blockedUsersMessage: '🚀 Wir sind fast da! Der offizielle Start von Vision AI Stream steht kurz bevor, und bald kannst du all die großartigen Funktionen erkunden, die wir für dich vorbereitet haben. Bleib dran, der Countdown hat bereits begonnen! 🕒',
      usernameOrEmailPlaceholder: "Geben Sie Ihre E-Mail oder Ihren Benutzernamen ein",
      passwordPlaceholder: "Geben Sie Ihr Passwort ein",
      pageLanguageLabel: "Seitensprache",
      loginSuccess: "Benutzer erfolgreich angemeldet!",
      loginError: "Falscher Benutzername oder Passwort!",
      loginButton: 'Anmelden/Registrieren',
      loginButtonTooltip: 'Mit dieser Schaltfläche können Sie sich anmelden oder registrieren. Verwenden Sie "email@beispiel.com" zur Registrierung oder nur "Benutzername" (E-Mail ohne "@") zur Anmeldung.',
      invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
      tokenResetError: "Fehler beim Zurücksetzen des Passworts. Überprüfen Sie, ob das Token gültig oder abgelaufen ist.",
      tokenResetSuccess: "Passwort erfolgreich zurückgesetzt.",
      incorrectPasswordEmailLink: "Falsches Passwort. Ein Link zum Zurücksetzen Ihres Passworts wurde per E-Mail gesendet.",
      planStatusInvalid: "Ungültiger oder fehlender Planstatus.",
      tokenPlaceholder: "Token zum Zurücksetzen des Passworts",
      newPasswordPlaceholder: "Geben Sie Ihr neues Passwort ein",
      resetPasswordButton: "Passwort zurücksetzen",
      passwordTooShort: "Das Passwort muss mindestens 6 Zeichen lang sein.",
      opportunityMessage: "Verpassen Sie nicht diese Gelegenheit! Bearbeiten Sie Videos mit KI und testen Sie Vision AI Stream jetzt kostenlos. 🎬✨",
      enterEmailMessage: "🔥 Geben Sie hier Ihre E-Mail ein, um sich anzumelden oder ein Konto zu erstellen! 🚀",
      enterPasswordMessage: "🔥 Geben Sie hier Ihr Passwort ein, um sich anzumelden oder ein Konto zu erstellen! 🚀"
    },
  
    it: {
      aboutUS: 'Chi Siamo',
      blockedUsersMessage: '🚀 Ci siamo quasi! Il lancio ufficiale di Vision AI Stream è in arrivo e presto potrai esplorare tutte le incredibili funzionalità che abbiamo preparato per te. Resta sintonizzato, il conto alla rovescia è già iniziato! 🕒',
      usernameOrEmailPlaceholder: "Inserisci la tua email o nome utente",
      passwordPlaceholder: "Inserisci la tua password",
      pageLanguageLabel: "Lingua della Pagina",
      loginSuccess: "Utente connesso con successo!",
      loginError: "Nome utente o password errati!",
      loginButton: 'Accedi/Registrati',
      loginButtonTooltip: 'Questo pulsante consente di accedere o registrarsi. Usa "email@esempio.com" per registrarti o solo "username" (e-mail senza "@") per accedere.',
      invalidEmail: "Inserisci un indirizzo email valido.",
      tokenResetError: "Errore durante il reset della password. Controlla se il token è valido o scaduto.",
      tokenResetSuccess: "Password reimpostata con successo.",
      incorrectPasswordEmailLink: "Password errata. Un link per reimpostare la password è stato inviato via email.",
      planStatusInvalid: "Stato del piano non valido o mancante.",
      tokenPlaceholder: "Token per reimpostare la password",
      newPasswordPlaceholder: "Inserisci la tua nuova password",
      resetPasswordButton: "Reimposta password",
      passwordTooShort: "La password deve contenere almeno 6 caratteri.",
      opportunityMessage: "Non perdere questa opportunità! Modifica video con l'IA e prova Vision AI Stream gratis ora. 🎬✨",
      enterEmailMessage: "🔥 Inserisci la tua email qui ora per accedere o creare il tuo account! 🚀",
      enterPasswordMessage: "🔥 Inserisci la tua password qui ora per accedere o creare il tuo account! 🚀"
    },
  
    ru: {
      aboutUS: 'О Нас',
      blockedUsersMessage: '🚀 Мы почти на месте! Официальный запуск Vision AI Stream уже близко, и скоро вы сможете изучить все удивительные функции, которые мы для вас подготовили. Следите за обновлениями, обратный отсчет уже начался! 🕒',
      usernameOrEmailPlaceholder: "Введите свой email или имя пользователя",
      passwordPlaceholder: "Введите ваш пароль",
      pageLanguageLabel: "Язык страницы",
      loginSuccess: "Пользователь успешно вошел!",
      loginError: "Неправильное имя пользователя или пароль!",
      loginButton: 'Войти/Зарегистрироваться',
      loginButtonTooltip: 'Эта кнопка позволяет войти или зарегистрироваться. Используйте "email@example.com" для регистрации или просто "username" (электронную почту без "@") для входа.',
      invalidEmail: "Пожалуйста, введите корректный адрес электронной почты.",
      tokenResetError: "Не удалось сбросить пароль. Убедитесь, что токен действителен или не истёк.",
      tokenResetSuccess: "Пароль успешно сброшен.",
      incorrectPasswordEmailLink: "Неверный пароль. Ссылка для сброса пароля отправлена на вашу почту.",
      planStatusInvalid: "Недействительный или отсутствующий статус плана.",
      tokenPlaceholder: "Токен для сброса пароля",
      newPasswordPlaceholder: "Введите новый пароль",
      resetPasswordButton: "Сбросить пароль",
      passwordTooShort: "Пароль должен содержать не менее 6 символов.",
      opportunityMessage: "Не упустите эту возможность! Редактируйте видео с ИИ и попробуйте Vision AI Stream бесплатно прямо сейчас. 🎬✨",
      enterEmailMessage: "🔥 Введите здесь свою электронную почту, чтобы войти или создать учетную запись! 🚀",
      enterPasswordMessage: "🔥 Введите здесь свой пароль, чтобы войти или создать учетную запись! 🚀"
    },
  
    zh: {
      aboutUS: '关于我们',
      blockedUsersMessage: '🚀 我们快到了！Vision AI Stream 的正式发布即将到来，您很快就能探索我们为您准备的所有精彩功能。敬请期待，倒计时已经开始！🕒',
      usernameOrEmailPlaceholder: "输入您的电子邮件或用户名",
      passwordPlaceholder: "输入您的密码",
      pageLanguageLabel: "页面语言",
      loginSuccess: "用户成功登录！",
      loginError: "用户名或密码错误！",
      loginButton: '登录/注册',
      loginButtonTooltip: '此按钮允许您登录或注册。使用 "email@example.com" 进行注册，或仅使用 "username"（不带 "@" 的电子邮件）登录。',
      invalidEmail: "请输入有效的电子邮件地址。",
      tokenResetError: "重置密码失败。请检查令牌是否有效或已过期。",
      tokenResetSuccess: "密码重置成功。",
      incorrectPasswordEmailLink: "密码错误。重置密码的链接已发送到您的电子邮箱。",
      planStatusInvalid: "无效或缺少计划状态。",
      tokenPlaceholder: "密码重置令牌",
      newPasswordPlaceholder: "请输入新密码",
      resetPasswordButton: "重置密码",
      passwordTooShort: "密码长度必须至少为6个字符。",
      opportunityMessage: "不要错过这个机会！使用AI编辑视频，立即免费试用Vision AI Stream。🎬✨",
      enterEmailMessage: "🔥 立即在此输入您的电子邮件以登录或创建账户！🚀",
      enterPasswordMessage: "🔥 立即在此输入您的密码以登录或创建账户！🚀"
    },
  
    ja: {
      aboutUS: '私たちについて',
      blockedUsersMessage: '🚀 もう少しです！Vision AI Stream の公式リリースが間もなく行われます。準備したすべての素晴らしい機能をまもなく体験いただけます。お楽しみに、カウントダウンはすでに始まっています！🕒',
      usernameOrEmailPlaceholder: "メールアドレスまたはユーザー名を入力してください",
      passwordPlaceholder: "パスワードを入力してください",
      pageLanguageLabel: "ページ言語",
      loginSuccess: "ユーザーが正常にログインしました！",
      loginError: "ユーザー名またはパスワードが正しくありません！",
      loginButton: 'ログイン/登録',
      loginButtonTooltip: 'このボタンを使用してログインまたは登録できます。"email@example.com" を使用して登録するか、"username"（"@" のないメール）だけを使用してログインしてください。',
      invalidEmail: "有効なメールアドレスを入力してください。",
      tokenResetError: "パスワードのリセットに失敗しました。トークンが有効または期限切れでないか確認してください。",
      tokenResetSuccess: "パスワードは正常にリセットされました。",
      incorrectPasswordEmailLink: "パスワードが間違っています。パスワードリセット用のリンクがメールに送信されました。",
      planStatusInvalid: "プランのステータスが無効、または存在しません。",
      tokenPlaceholder: "パスワードリセットトークン",
      newPasswordPlaceholder: "新しいパスワードを入力してください",
      resetPasswordButton: "パスワードをリセット",
      passwordTooShort: "パスワードは6文字以上である必要があります。",
      opportunityMessage: "このチャンスをお見逃しなく！AIで動画を編集し、今すぐVision AI Streamを無料で試しましょう。🎬✨",
      enterEmailMessage: "🔥 ここにメールアドレスを入力して、ログインまたはアカウントを作成してください！🚀",
      enterPasswordMessage: "🔥 ここにパスワードを入力して、ログインまたはアカウントを作成してください！🚀"
    },
  
    ko: {
      aboutUS: '회사 소개',
      blockedUsersMessage: '🚀 거의 다 왔습니다! Vision AI Stream의 공식 출시가 다가오고 있으며, 준비된 놀라운 기능들을 곧 탐험할 수 있습니다. 기대해 주세요. 카운트다운이 이미 시작되었습니다! 🕒',
      usernameOrEmailPlaceholder: "이메일 또는 사용자 이름을 입력하세요",
      passwordPlaceholder: "비밀번호를 입력하십시오",
      pageLanguageLabel: "페이지 언어",
      loginSuccess: "사용자가 성공적으로 로그인했습니다!",
      loginError: "잘못된 사용자 이름 또는 비밀번호!",
      loginButton: '로그인/회원가입',
      loginButtonTooltip: '"email@example.com"을 사용하여 등록하거나 "username" ("@" 없이 이메일)을 사용하여 로그인할 수 있습니다.',
      invalidEmail: "유효한 이메일 주소를 입력하세요.",
      tokenResetError: "비밀번호 재설정에 실패했습니다. 토큰이 유효하거나 만료되지 않았는지 확인하세요.",
      tokenResetSuccess: "비밀번호가 성공적으로 재설정되었습니다.",
      incorrectPasswordEmailLink: "잘못된 비밀번호입니다. 비밀번호 재설정을 위한 링크가 이메일로 전송되었습니다.",
      planStatusInvalid: "유효하지 않거나 누락된 플랜 상태입니다.",
      tokenPlaceholder: "비밀번호 재설정 토큰",
      newPasswordPlaceholder: "새 비밀번호를 입력하세요",
      resetPasswordButton: "비밀번호 재설정",
      passwordTooShort: "비밀번호는 최소 6자 이상이어야 합니다.",
      opportunityMessage: "이 기회를 놓치지 마세요! AI로 동영상을 편집하고 지금 Vision AI Stream을 무료로 사용해 보세요. 🎬✨",
      enterEmailMessage: "🔥 지금 여기에서 이메일을 입력하고 로그인하거나 계정을 만드세요! 🚀",
      enterPasswordMessage: "🔥 지금 여기에서 비밀번호를 입력하고 로그인하거나 계정을 만드세요! 🚀"
    },
  
    hi: {
      aboutUS: 'हमारे बारे में',
      blockedUsersMessage: '🚀 हम लगभग वहाँ पहुँच चुके हैं! Vision AI Stream का आधिकारिक लॉन्च जल्द ही आ रहा है, और आप जल्द ही उन सभी अद्भुत सुविधाओं का पता लगा सकेंगे जो हमने आपके लिए तैयार की हैं। बने रहें, काउंटडाउन शुरू हो चुका है! 🕒',
      usernameOrEmailPlaceholder: "अपना ईमेल या उपयोगकर्ता नाम दर्ज करें",
      passwordPlaceholder: "अपना पासवर्ड दर्ज करें",
      pageLanguageLabel: "पेज भाषा",
      loginSuccess: "उपयोगकर्ता सफलतापूर्वक लॉग इन हुआ!",
      loginError: "अमान्य उपयोगकर्ता नाम या पासवर्ड!",
      loginButton: 'लॉगिन/पंजीकरण',
      loginButtonTooltip: 'यह बटन आपको लॉगिन या पंजीकरण करने की अनुमति देता है। पंजीकरण के लिए "email@example.com" का उपयोग करें या लॉगिन के लिए केवल "username" (ईमेल बिना "@") का उपयोग करें।',
      invalidEmail: "कृपया एक मान्य ईमेल पता दर्ज करें।",
      tokenResetError: "पासवर्ड रीसेट करने में विफल। कृपया जांचें कि टोकन वैध है या समाप्त हो गया है।",
      tokenResetSuccess: "पासवर्ड सफलतापूर्वक रीसेट हो गया है।",
      incorrectPasswordEmailLink: "गलत पासवर्ड। आपका पासवर्ड रीसेट लिंक ईमेल पर भेज दिया गया है।",
      planStatusInvalid: "प्लान का स्टेटस अमान्य या अनुपलब्ध है।",
      tokenPlaceholder: "पासवर्ड रीसेट टोकन",
      newPasswordPlaceholder: "अपना नया पासवर्ड दर्ज करें",
      resetPasswordButton: "पासवर्ड रीसेट करें",
      passwordTooShort: "पासवर्ड कम से कम 6 वर्णों का होना चाहिए।",
      opportunityMessage: "इस अवसर को न चूकें! AI के साथ वीडियो संपादित करें और अभी Vision AI Stream को मुफ्त में आज़माएं। 🎬✨",
      enterEmailMessage: "🔥 यहाँ अभी अपना ईमेल दर्ज करें और लॉगिन करें या अपना खाता बनाएं! 🚀",
      enterPasswordMessage: "🔥 यहाँ अभी अपना पासवर्ड दर्ज करें और लॉगिन करें या अपना खाता बनाएं! 🚀"
    },
  
    ar: {
      aboutUS: 'معلومات عنا',
      blockedUsersMessage: '🚀 نحن على وشك الانتهاء! الإطلاق الرسمي لـ Vision AI Stream قادم قريبًا، وستتمكن قريبًا من استكشاف جميع الميزات الرائعة التي أعددناها لك. ترقبوا، العد التنازلي قد بدأ بالفعل! 🕒',
      usernameOrEmailPlaceholder: 'أدخل بريدك الإلكتروني أو اسم المستخدم',
      passwordPlaceholder: "أدخل كلمة المرور الخاصة بك",
      pageLanguageLabel: "لغة الصفحة",
      loginSuccess: "تم تسجيل دخول المستخدم بنجاح!",
      loginError: "اسم المستخدم أو كلمة المرور غير صحيحة!",
      loginButton: 'تسجيل الدخول/تسجيل',
      loginButtonTooltip: 'يتيح لك هذا الزر تسجيل الدخول أو التسجيل. استخدم "email@example.com" للتسجيل أو فقط "username" (البريد الإلكتروني بدون "@") لتسجيل الدخول.',
      invalidEmail: "يرجى إدخال عنوان بريد إلكتروني صالح.",
      tokenResetError: "فشل في إعادة تعيين كلمة المرور. يرجى التحقق مما إذا كان الرمز صالحًا أو منتهي الصلاحية.",
      tokenResetSuccess: "تم إعادة تعيين كلمة المرور بنجاح.",
      incorrectPasswordEmailLink: "كلمة مرور غير صحيحة. تم إرسال رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني.",
      planStatusInvalid: "حالة الخطة غير صالحة أو مفقودة.",
      tokenPlaceholder: "رمز إعادة تعيين كلمة المرور",
      newPasswordPlaceholder: "أدخل كلمة المرور الجديدة",
      resetPasswordButton: "إعادة تعيين كلمة المرور",
      passwordTooShort: "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل.",
      opportunityMessage: "لا تفوت هذه الفرصة! حرر الفيديوهات باستخدام الذكاء الاصطناعي وجرب Vision AI Stream مجانًا الآن. 🎬✨",
      enterEmailMessage: "🔥 أدخل بريدك الإلكتروني هنا الآن لتسجيل الدخول أو إنشاء حساب! 🚀",
      enterPasswordMessage: "🔥 أدخل كلمة المرور هنا الآن لتسجيل الدخول أو إنشاء حساب! 🚀"
    },
  
    tr: {
      aboutUS: 'Hakkımızda',
      blockedUsersMessage: '🚀 Neredeyse hazırız! Vision AI Stream\'in resmi lansmanı yakında geliyor ve sizin için hazırladığımız tüm harika özellikleri yakında keşfedebileceksiniz. Takipte kalın, geri sayım başladı! 🕒',
      usernameOrEmailPlaceholder: 'E-posta adresinizi veya kullanıcı adınızı girin',
      passwordPlaceholder: "Şifrenizi giriniz",
      pageLanguageLabel: "Sayfa Dili",
      loginSuccess: "Kullanıcı başarıyla giriş yaptı!",
      loginError: "Hatalı kullanıcı adı veya şifre!",
      loginButton: 'Giriş/Kayıt',
      loginButtonTooltip: 'Bu düğme giriş yapmanıza veya kaydolmanıza olanak tanır. Kayıt için "email@example.com" veya giriş için yalnızca "kullanıcı adı" ("@" olmadan e-posta) kullanın.',
      invalidEmail: "Lütfen geçerli bir e-posta adresi girin.",
      tokenResetError: "Şifre sıfırlanamadı. Token geçerli mi veya süresi doldu mu kontrol edin.",
      tokenResetSuccess: "Şifre başarıyla sıfırlandı.",
      incorrectPasswordEmailLink: "Yanlış şifre. Şifrenizi sıfırlamak için bir bağlantı e-postanıza gönderildi.",
      planStatusInvalid: "Geçersiz veya eksik plan durumu.",
      tokenPlaceholder: "Şifre sıfırlama tokenı",
      newPasswordPlaceholder: "Yeni şifrenizi girin",
      resetPasswordButton: "Şifreyi Sıfırla",
      passwordTooShort: "Şifre en az 6 karakter uzunluğunda olmalıdır.",
      opportunityMessage: "Bu fırsatı kaçırmayın! Yapay zeka ile videoları düzenleyin ve Vision AI Stream’i şimdi ücretsiz deneyin. 🎬✨",
      enterEmailMessage: "🔥 Şimdi e-postanızı buraya girin ve giriş yapın veya hesap oluşturun! 🚀",
      enterPasswordMessage: "🔥 Şimdi şifrenizi buraya girin ve giriş yapın veya hesap oluşturun! 🚀"
    },
  
    nl: {
      aboutUS: 'Over Ons',
      blockedUsersMessage: '🚀 We zijn er bijna! De officiële lancering van Vision AI Stream komt eraan en binnenkort kun je alle geweldige functies ontdekken die we voor jou hebben voorbereid. Blijf op de hoogte, de aftelling is begonnen! 🕒',
      usernameOrEmailPlaceholder: 'Voer uw e-mail of gebruikersnaam in',
      passwordPlaceholder: "Voer uw wachtwoord in",
      pageLanguageLabel: "Paginataal",
      loginSuccess: "Gebruiker succesvol ingelogd!",
      loginError: "Onjuiste gebruikersnaam of wachtwoord!",
      loginButton: 'Inloggen/Registreren',
      loginButtonTooltip: 'Met deze knop kunt u inloggen of registreren. Gebruik "email@example.com" voor registratie of alleen "gebruikersnaam" (e-mail zonder "@") om in te loggen.',
      invalidEmail: "Voer een geldig e-mailadres in.",
      tokenResetError: "Wachtwoord resetten mislukt. Controleer of de token geldig of verlopen is.",
      tokenResetSuccess: "Wachtwoord succesvol gereset.",
      incorrectPasswordEmailLink: "Onjuist wachtwoord. Er is een link verzonden naar uw e-mail om uw wachtwoord te resetten.",
      planStatusInvalid: "Ongeldige of ontbrekende planstatus.",
      tokenPlaceholder: "Token voor wachtwoordreset",
      newPasswordPlaceholder: "Voer uw nieuwe wachtwoord in",
      resetPasswordButton: "Wachtwoord Resetten",
      passwordTooShort: "Het wachtwoord moet minimaal 6 tekens lang zijn.",
      opportunityMessage: "Mis deze kans niet! Bewerk video's met AI en probeer Vision AI Stream nu gratis. 🎬✨",
      enterEmailMessage: "🔥 Voer hier nu je e-mail in om in te loggen of een account aan te maken! 🚀",
      enterPasswordMessage: "🔥 Voer hier nu je wachtwoord in om in te loggen of een account aan te maken! 🚀"
    },
  
    sv: {
      aboutUS: 'Om Oss',
      blockedUsersMessage: '🚀 Vi är nästan där! Den officiella lanseringen av Vision AI Stream närmar sig, och du kommer snart att kunna utforska alla fantastiska funktioner vi har förberett för dig. Håll utkik, nedräkningen har redan börjat! 🕒',
      usernameOrEmailPlaceholder: 'Ange din e-postadress eller användarnamn',
      passwordPlaceholder: "Ange ditt lösenord",
      pageLanguageLabel: "Sidans språk",
      loginSuccess: "Användare inloggad framgångsrikt!",
      loginError: "Fel användarnamn eller lösenord!",
      loginButton: 'Logga in/Registrera',
      loginButtonTooltip: 'Den här knappen låter dig logga in eller registrera dig. Använd "email@example.com" för registrering eller bara "användarnamn" (e-post utan "@") för inloggning.',
      invalidEmail: "Vänligen ange en giltig e-postadress.",
      tokenResetError: "Det gick inte att återställa lösenordet. Kontrollera om token är giltig eller har gått ut.",
      tokenResetSuccess: "Lösenord återställdes framgångsrikt.",
      incorrectPasswordEmailLink: "Fel lösenord. En länk för att återställa ditt lösenord har skickats till din e-post.",
      planStatusInvalid: "Ogiltig eller saknad planstatus.",
      tokenPlaceholder: "Token för lösenordsåterställning",
      newPasswordPlaceholder: "Ange ditt nya lösenord",
      resetPasswordButton: "Återställ lösenord",
      passwordTooShort: "Lösenordet måste vara minst 6 tecken långt.",
      opportunityMessage: "Missa inte denna möjlighet! Redigera videor med AI och testa Vision AI Stream gratis nu. 🎬✨",
      enterEmailMessage: "🔥 Ange din e-post här nu för att logga in eller skapa ett konto! 🚀",
      enterPasswordMessage: "🔥 Ange ditt lösenord här nu för att logga in eller skapa ett konto! 🚀"
    },
  
    no: {
      aboutUS: 'Om Oss',
      blockedUsersMessage: '🚀 Vi er nesten der! Den offisielle lanseringen av Vision AI Stream nærmer seg, og du vil snart kunne utforske alle de fantastiske funksjonene vi har forberedt for deg. Følg med, nedtellingen har allerede begynt! 🕒',
      usernameOrEmailPlaceholder: 'Skriv inn e-posten din eller brukernavn',
      passwordPlaceholder: "Skriv inn passordet ditt",
      pageLanguageLabel: "Sidens språk",
      loginSuccess: "Bruker logget inn!",
      loginError: "Feil brukernavn eller passord!",
      loginButton: 'Logg inn/Registrer',
      loginButtonTooltip: 'Denne knappen lar deg logge inn eller registrere deg. Bruk "email@example.com" for registrering eller bare "brukernavn" (e-post uten "@") for pålogging.',
      invalidEmail: "Vennligst oppgi en gyldig e-postadresse.",
      tokenResetError: "Kunne ikke tilbakestille passordet. Kontroller at tokenet er gyldig eller ikke er utløpt.",
      tokenResetSuccess: "Passordet ble tilbakestilt.",
      incorrectPasswordEmailLink: "Feil passord. En lenke for tilbakestilling av passordet er sendt til e-posten din.",
      planStatusInvalid: "Ugyldig eller manglende planstatus.",
      tokenPlaceholder: "Token for tilbakestilling av passord",
      newPasswordPlaceholder: "Skriv inn det nye passordet ditt",
      resetPasswordButton: "Tilbakestill passord",
      passwordTooShort: "Passordet må være minst 6 tegn langt.",
      opportunityMessage: "Ikke gå glipp av denne muligheten! Rediger videoer med AI og prøv Vision AI Stream gratis nå. 🎬✨",
      enterEmailMessage: "🔥 Skriv inn e-posten din her nå for å logge inn eller opprette en konto! 🚀",
      enterPasswordMessage: "🔥 Skriv inn passordet ditt her nå for å logge inn eller opprette en konto! 🚀"
    },
  
    pl: {
      aboutUS: 'O Nas',
      blockedUsersMessage: '🚀 Jesteśmy już prawie na miejscu! Oficjalna premiera Vision AI Stream już wkrótce, a Ty będziesz mógł wkrótce odkryć wszystkie niesamowite funkcje, które dla Ciebie przygotowaliśmy. Bądź na bieżąco, odliczanie już się rozpoczęło! 🕒',
      usernameOrEmailPlaceholder: 'Wpisz swój email lub nazwę użytkownika',
      passwordPlaceholder: "Wprowadź swoje hasło",
      pageLanguageLabel: "Język strony",
      loginSuccess: "Użytkownik zalogowany pomyślnie!",
      loginError: "Nieprawidłowa nazwa użytkownika lub hasło!",
      loginButton: 'Zaloguj/Zarejestruj',
      loginButtonTooltip: 'Ten przycisk umożliwia zalogowanie się lub rejestrację. Użyj "email@example.com" do rejestracji lub po prostu "nazwa użytkownika" (email bez "@") do logowania.',
      invalidEmail: "Proszę wprowadzić poprawny adres e-mail.",
      tokenResetError: "Nie udało się zresetować hasła. Sprawdź, czy token jest ważny lub czy nie wygasł.",
      tokenResetSuccess: "Hasło zostało pomyślnie zresetowane.",
      incorrectPasswordEmailLink: "Nieprawidłowe hasło. Link do zresetowania hasła wysłano na Twój adres e-mail.",
      planStatusInvalid: "Nieprawidłowy lub nieistniejący status planu.",
      tokenPlaceholder: "Token do resetu hasła",
      newPasswordPlaceholder: "Wpisz nowe hasło",
      resetPasswordButton: "Zresetuj hasło",
      passwordTooShort: "Hasło musi mieć co najmniej 6 znaków.",
      opportunityMessage: "Nie przegap tej okazji! Edytuj filmy za pomocą AI i wypróbuj Vision AI Stream za darmo już teraz. 🎬✨",
      enterEmailMessage: "🔥 Wpisz tutaj swój e-mail, aby zalogować się lub utworzyć konto! 🚀",
      enterPasswordMessage: "🔥 Wpisz tutaj swoje hasło, aby zalogować się lub utworzyć konto! 🚀"
    },
  
    he: {
      aboutUS: 'עלינו',
      blockedUsersMessage: '🚀 אנחנו כמעט שם! ההשקה הרשמית של Vision AI Stream מתקרבת, ובקרוב תוכל לחקור את כל הפונקציות המדהימות שהכנו עבורך. הישאר מעודכן, הספירה לאחור כבר החלה! 🕒',
      usernameOrEmailPlaceholder: 'הזן את האימייל או שם המשתמש שלך',
      passwordPlaceholder: "הזן את הסיסמה שלך",
      pageLanguageLabel: "שפת העמוד",
      loginSuccess: "המשתמש נכנס בהצלחה!",
      loginError: "שם משתמש או סיסמה שגויים!",
      loginButton: 'התחבר/הרשמה',
      loginButtonTooltip: 'לחצן זה מאפשר לך להתחבר או להירשם. השתמש ב-"email@example.com" להרשמה או רק ב-"username" (דוא"ל ללא "@") להתחברות.',
      invalidEmail: "אנא הזן כתובת אימייל חוקית.",
      tokenResetError: "נכשל באיפוס הסיסמה. בדוק אם הטוקן תקף או שפג תוקפו.",
      tokenResetSuccess: "הסיסמה אופסה בהצלחה.",
      incorrectPasswordEmailLink: "סיסמה שגויה. קישור לאיפוס הסיסמה נשלח לכתובת האימייל שלך.",
      planStatusInvalid: "סטטוס התוכנית לא חוקי או חסר.",
      tokenPlaceholder: "אסימון לאיפוס הסיסמה",
      newPasswordPlaceholder: "הזן את הסיסמה החדשה שלך",
      resetPasswordButton: "אפס סיסמה",
      passwordTooShort: "הסיסמה חייבת להיות באורך של לפחות 6 תווים.",
      opportunityMessage: "אל תפספסו את ההזדמנות! ערכו סרטונים עם בינה מלאכותית ונסו את Vision AI Stream בחינם עכשיו. 🎬✨",
      enterEmailMessage: "🔥 הזן את הדוא\"ל שלך כאן עכשיו כדי להתחבר או ליצור חשבון! 🚀",
      enterPasswordMessage: "🔥 הזן את הסיסמה שלך כאן עכשיו כדי להתחבר או ליצור חשבון! 🚀"
    },
  
    fi: {
      aboutUS: 'Meistä',
      blockedUsersMessage: '🚀 Olemme melkein perillä! Vision AI Streamin virallinen julkaisu on tulossa, ja pian voit tutkia kaikki upeat ominaisuudet, jotka olemme valmistelleet sinulle. Pysy kuulolla, lähtölaskenta on jo alkanut! 🕒',
      usernameOrEmailPlaceholder: 'Syötä sähköpostisi tai käyttäjänimesi',
      passwordPlaceholder: "Anna salasanasi",
      pageLanguageLabel: "Sivun kieli",
      loginSuccess: "Käyttäjä kirjautui onnistuneesti!",
      loginError: "Virheellinen käyttäjänimi tai salasana!",
      loginButton: 'Kirjaudu/Rekisteröidy',
      loginButtonTooltip: 'Tämä painike sallii kirjautumisen tai rekisteröitymisen. Käytä "email@example.com" rekisteröitymiseen tai vain "käyttäjätunnusta" (sähköposti ilman "@") kirjautumiseen.',
      invalidEmail: "Syötä voimassa oleva sähköpostiosoite.",
      tokenResetError: "Salasanan palauttaminen epäonnistui. Tarkista onko token voimassa tai vanhentunut.",
      tokenResetSuccess: "Salasana on palautettu onnistuneesti.",
      incorrectPasswordEmailLink: "Virheellinen salasana. Linkki salasanan palauttamiseksi on lähetetty sähköpostiisi.",
      planStatusInvalid: "Virheellinen tai puuttuva tilan tila.",
      tokenPlaceholder: "Salasanan palautus -token",
      newPasswordPlaceholder: "Syötä uusi salasanasi",
      resetPasswordButton: "Palauta salasana",
      passwordTooShort: "Salasanan on oltava vähintään 6 merkkiä pitkä.",
      opportunityMessage: "Älä missaa tätä tilaisuutta! Muokkaa videoita tekoälyllä ja kokeile Vision AI Streamia ilmaiseksi nyt. 🎬✨",
      enterEmailMessage: "🔥 Syötä sähköpostisi tähän nyt kirjautuaksesi sisään tai luodaksesi tilin! 🚀",
      enterPasswordMessage: "🔥 Syötä salasanasi tähän nyt kirjautuaksesi sisään tai luodaksesi tilin! 🚀"
    },
  
    el: {
      aboutUS: 'Σχετικά με Εμάς',
      blockedUsersMessage: '🚀 Είμαστε σχεδόν εκεί! Η επίσημη κυκλοφορία του Vision AI Stream πλησιάζει και σύντομα θα μπορείτε να εξερευνήσετε όλες τις εκπληκτικές δυνατότητες που ετοιμάσαμε για εσάς. Μείνετε συντονισμένοι, η αντίστροφη μέτρηση έχει ήδη ξεκινήσει! 🕒',
      usernameOrEmailPlaceholder: 'Εισάγετε το email ή το όνομα χρήστη σας',
      passwordPlaceholder: "Εισαγάγετε τον κωδικό πρόσβασής σας",
      pageLanguageLabel: "Γλώσσα σελίδας",
      loginSuccess: "Ο χρήστης συνδέθηκε με επιτυχία!",
      loginError: "Λάθος όνομα χρήστη ή κωδικός πρόσβασης!",
      loginButton: 'Σύνδεση/Εγγραφή',
      loginButtonTooltip: 'Αυτό το κουμπί σας επιτρέπει να συνδεθείτε ή να εγγραφείτε. Χρησιμοποιήστε "email@example.com" για εγγραφή ή μόνο "όνομα χρήστη" (email χωρίς "@") για σύνδεση.',
      invalidEmail: "Παρακαλώ εισάγετε μια έγκυρη διεύθυνση email.",
      tokenResetError: "Αποτυχία επαναφοράς κωδικού. Ελέγξτε αν το token είναι έγκυρο ή έχει λήξει.",
      tokenResetSuccess: "Ο κωδικός πρόσβασης επαναφέρθηκε με επιτυχία.",
      incorrectPasswordEmailLink: "Λανθασμένος κωδικός. Έχει σταλεί ένας σύνδεσμος επαναφοράς κωδικού πρόσβασης στο email σας.",
      planStatusInvalid: "Μη έγκυρη ή ανύπαρκτη κατάσταση πλάνου.",
      tokenPlaceholder: "Token επαναφοράς κωδικού πρόσβασης",
      newPasswordPlaceholder: "Εισάγετε τον νέο κωδικό πρόσβασής σας",
      resetPasswordButton: "Επαναφορά κωδικού πρόσβασης",
      passwordTooShort: "Ο κωδικός πρόσβασης πρέπει να αποτελείται τουλάχιστον από 6 χαρακτήρες.",
      opportunityMessage: "Μην χάσετε αυτήν την ευκαιρία! Επεξεργαστείτε βίντεο με AI και δοκιμάστε το Vision AI Stream δωρεάν τώρα. 🎬✨",
      enterEmailMessage: "🔥 Εισαγάγετε το email σας εδώ τώρα για να συνδεθείτε ή να δημιουργήσετε λογαριασμό! 🚀",
      enterPasswordMessage: "🔥 Εισαγάγετε τον κωδικό σας εδώ τώρα για να συνδεθείτε ή να δημιουργήσετε λογαριασμό! 🚀"
    },
  
    da: {
      aboutUS: 'Om Os',
      blockedUsersMessage: '🚀 Vi er næsten der! Den officielle lancering af Vision AI Stream er lige om hjørnet, og snart kan du udforske alle de fantastiske funktioner, vi har forberedt til dig. Hold øje, nedtællingen er allerede begyndt! 🕒',
      usernameOrEmailPlaceholder: 'Indtast din e-mail eller brugernavn',
      passwordPlaceholder: "Indtast din adgangskode",
      pageLanguageLabel: "Sidens sprog",
      loginSuccess: "Bruger logget ind!",
      loginError: "Forkert brugernavn eller adgangskode!",
      loginButton: 'Log ind/Registrer',
      loginButtonTooltip: 'Denne knap giver dig mulighed for at logge ind eller registrere. Brug "email@example.com" til registrering eller kun "brugernavn" (e-mail uden "@") til login.',
      invalidEmail: "Angiv en gyldig e-mailadresse.",
      tokenResetError: "Kunne ikke nulstille adgangskoden. Kontroller, om token er gyldig eller udløbet.",
      tokenResetSuccess: "Adgangskoden blev nulstillet med succes.",
      incorrectPasswordEmailLink: "Forkert adgangskode. Et link til at nulstille din adgangskode er sendt til din e-mail.",
      planStatusInvalid: "Ugyldig eller manglende planstatus.",
      tokenPlaceholder: "Token til nulstilling af adgangskode",
      newPasswordPlaceholder: "Indtast din nye adgangskode",
      resetPasswordButton: "Nulstil adgangskode",
      passwordTooShort: "Ο κωδικός πρόσβασης πρέπει να αποτελείται τουλάχιστον από 6 χαρακτήρες.",
      opportunityMessage: "Gå ikke glip af denne mulighed! Rediger videoer med AI og prøv Vision AI Stream gratis nu. 🎬✨",
      enterEmailMessage: "🔥 Indtast din e-mail her nu for at logge ind eller oprette en konto! 🚀",
      enterPasswordMessage: "🔥 Indtast din adgangskode her nu for at logge ind eller oprette en konto! 🚀"
    }
  };
  
  export default translations;
  